import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  ImageInput,
  ImageField,
  SelectInput,
  required,
  maxLength,
  useNotify,
  useRedirect,
} from "react-admin";

const pageChoices = [
  { id: "sellers", name: "Distribuidores" },
  { id: "service", name: "Servicio técnico" },
  { id: "blog", name: "Blog" },
  { id: "contact", name: "Contacto" },
];

export const BannerCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    notify("Banner creado exitosamente", {
      type: "info",
      messageArgs: { smart_count: 1, name: data.name },
    });
    redirect("list", props.basePath || "/banners", data.id, data);
  };

  return (
    <Create {...props} mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <div
          style={{
            display: "flex",
            gap: "10px",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <TextInput
            source="name"
            label="Nombre"
            validate={[required(), maxLength(200)]}
          />
          <SelectInput
            source="page"
            label="Página"
            choices={pageChoices}
            validate={[required()]}
          />
        </div>
        <TextInput
          source="link"
          label="URL de destino"
          validate={[maxLength(200)]}
        />
        <ImageInput
          source="image"
          label="Imagen"
          accept={{
            "image/*": [".png", ".jpg", ".jpeg", ".gif"],
          }}
          placeholder="Haz clic aquí o arrastra y suelta la imagen"
          options={{
            preventDropOnDocument: true,
            validator: (file) => {
              if (!file.type.startsWith("image/")) {
                return {
                  code: "invalid-file-type",
                  message: "Solo se permiten imágenes",
                };
              }
              return null;
            },
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <BooleanInput source="active" label="Activo" defaultValue={true} />
      </SimpleForm>
    </Create>
  );
};
